// Admin: hvem har skrudd gruppe-chat opt-in av/på (investorer + låntakere).
// Kaller den admin-gatede /admin/group-optin. Mock-veksling via VITE_USE_MOCKS.
import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/lib/apiClient";
import { env } from "@/lib/env";

export interface AdminGroupOptIn {
  accountId: number;
  oblinorId: number;
  email: string;
  role: "investor" | "loaner";
  name: string | null;
  optIn: boolean;
}

const mockAccounts: AdminGroupOptIn[] = [
  { accountId: 1, oblinorId: 6510, email: "post@ppe-eiendom.no", role: "loaner", name: "LEI 20 AS", optIn: true },
  { accountId: 2, oblinorId: 53855, email: "arne@example.no", role: "investor", name: "Arne Skjelvan", optIn: true },
  { accountId: 3, oblinorId: 11481, email: "ronny@example.no", role: "investor", name: "Ronny Atle Bertelsen", optIn: false },
];

async function fetchGroupOptIn(): Promise<AdminGroupOptIn[]> {
  if (env.useMocks) return mockAccounts;
  const r = await apiClient.get<{ ok: true; accounts: AdminGroupOptIn[] }>("/admin/group-optin");
  return r.accounts;
}

export function useGroupOptIn() {
  return useQuery({
    queryKey: ["admin", "group-optin"],
    queryFn: fetchGroupOptIn,
    staleTime: 30_000,
  });
}
